import {
  ShieldCheck,
  TrendingUp,
  Users,
  CircleCheckBig,
  Lightbulb,
  MessageCircle,
} from "lucide-react";
import React from "react";

const WhyChoose = () => {
  const features = [
    {
      icon: <CircleCheckBig />,
      title: "Process Over Predictions",
      description:
        "No tips. No stock calls. We follow a structured investing process backed by risk awareness and discipline.",
    },
    {
      icon: <TrendingUp />,
      title: "Long-Term Wealth Focus",
      description:
        "We believe real wealth is built through SIPs, asset allocation, and patience not short-term excitement.",
    },
    {
      icon: <Lightbulb />,
      title: "Investor Education First",
      description:
        "We help you understand why you invest, how markets behave, and what to expect over market cycles.",
    },
    {
      icon: <ShieldCheck />,
      title: "Risk Before Return",
      description:
        "Protecting capital always comes first. Returns matter, but unmanaged risk destroys long-term wealth.",
    },
    {
      icon: <MessageCircle />,
      title: "Simple, Honest Guidance",
      description:
        "Clear communication, practical advice, and full transparency without jargon or hidden agendas.",
    },
    {
      icon: <Users />,
      title: "Built for Indian Investors",
      description:
        "Designed for salaried professionals and families navigating volatility, taxes, and real-life financial goals.",
    },
  ];

  return (
    <div className="w-full border border-black-dark-200 flex flex-col items-center rounded-3xl py-24">
      <section className="w-full max-w-screen-xl px-6 md:px-10">
        {/* Heading Section */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-6xl xl:text-7xl font-bold text-white">
            Why Investors Trust{" "}
            <span className="text-primary1">TradeTact?</span>
          </h2>
          <p className="mt-6 text-gray-200 text-base sm:text-lg">
            We focus on process, discipline, and long-term thinking not noise,
            tips, or shortcuts.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-black-dark-200 p-6 sm:p-8 rounded-2xl shadow-md hover:shadow-xl transition"
            >
              <div className="flex items-start space-x-5">
                {/* Icon Wrapper */}
                <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16">
                  {React.cloneElement(feature.icon, {
                    className: "w-8 h-8 sm:w-9 sm:h-9 text-primary1",
                  })}
                </div>
                {/* Content */}
                <div>
                  <h3 className="text-lg sm:text-xl font-semibold text-white">
                    {feature.title}
                  </h3>
                  <p className="text-gray-400 text-sm sm:text-base mt-2">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default WhyChoose;
